import { IRequesterInfo } from '../../../../../base/models'
import { ClientProxy } from '../../../../../base/proxy/clientProxy'
import { IProductIsActive, IProductVisibility } from '../models/models'

export class CheckVisibilityApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'admin/product/checkVisibility',
      requesterInfo,
    })
  }

  public async checkVisibilityApi(request: string): Promise<IProductVisibility[]> {
    this.props.url = `${this.props.url}?matNumber=${request}`
    return await this.getAsync<any[]>()
  }
}
